module.exports = __webpack_public_path__ + "img/prefight3.584507a8.jpg";